import PropTypes from 'prop-types';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuthorizationV2 } from 'components/common/Authorization/AuthHookV2';

interface ProtectedRouteV2Props {
    element: React.ReactNode;
    requiredPermission: string;
};

const ProtectedRouteV2 = ({
    element,
    requiredPermission,
}: ProtectedRouteV2Props) => {
    const {isAuthorized, isLoading} = useAuthorizationV2(requiredPermission);
   
    if (isLoading) {
       return null;
    }

    if (!isAuthorized) {
        return <Navigate
            replace
            to={{ pathname: `/unauthorized/${requiredPermission}` }}
        />;
    }

    return element;
};

export default ProtectedRouteV2;
